import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, FormControl, FormLabel, TextField } from '@mui/material';

import appRoutes from '../../routes/appRoutes';
import BBButton from '../UI/BBButton';

const ForgotPasswordForm = (props) => {
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .min(7, 'Email must be of minimum length 7')
        .email('Please provide a valid Email Address')
        .required('Please enter the Email Address'),
    }),
    onSubmit: async (values) => {
      await props.onFormSubmit(values);
    },
  });
  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <FormControl fullWidth>
        <FormLabel required>Email Address</FormLabel>
        <TextField
          id="email"
          name="email"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
        />
      </FormControl>
      <Box my={3}>
        <BBButton
          fullWidth
          text="Submit"
          loadingText="Submitting..."
          loading={formik.isSubmitting}
        />
      </Box>

      <Box textAlign="center">
        <NavLink
          to={appRoutes.login}
          style={{ color: '#999', fontSize: '14px', textDecoration: 'none' }}
          className="color-dark-grey"
          href="/">
          <span>Back to Login</span>
        </NavLink>
      </Box>
      <Box mt={1} className="error">
        {props.serverErrorMsg}
      </Box>
    </Box>
  );
};

export default ForgotPasswordForm;

ForgotPasswordForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string,
};
